export const retryButton = {
  color: 'rgb(72, 151, 248)',
  cursor: 'pointer',
  outline: 'none',
}
